import { useCallback, useMemo } from "react"
import { IUbicacionProducto } from "../../../../../shared/interfaces/erp/inventario";
import { MRT_ColumnDef } from "material-react-table";
import { EstadoComponente } from "@/shared/components/ui";
import { cellNotFilter, emptyCellObject, EstadoEstadoStockENUM, formatDateWithTime } from "@/shared";
import { Button } from "@mui/material";
import { useSeriesReporteStock } from "./useSeriesReporteStock.store";
import { IDataSerieParams } from "@/shared/interfaces/erp/administration/productofactorserie.interface";
import { IDataProducto } from "@/shared/interfaces";
import { ReporteStockHistorico } from "@/shared/interfaces/erp/movimiento-inventario/reporte-stock-historico.interface";

export const useTableColumnsReporteStock = () => {

  const handleReporteStock = useCallback(
    (
      stock: number,
      stockSeguridad: number,
      stockMinimo: number,
      stockMax: number
    ): { text: string, color: string } => {

      if (stock <= 0) return {
        text: EstadoEstadoStockENUM.AGOTADO,
        color: 'grey'
      }

      if (stock <= stockMinimo) return {
        text: EstadoEstadoStockENUM.CRITICO,
        color: 'red'
      }

      if (stock <= stockSeguridad) return {
        text: 'MENOR AL STOCK DE SEGURIDAD',
        color: 'red'
      }

      if (stock > stockMax) return {
        text: EstadoEstadoStockENUM.NORMAL,
        color: 'green'
      }

      return {
        text: EstadoEstadoStockENUM.NORMAL,
        color: 'green'
      }

      /* if (stock == 0)
        return {
          text: EstadoEstadoStockENUM.AGOTADO,
          color: 'grey'
        }

      const stockNormal = (stock * 100) / stockSeguridad;

      if (stockNormal >= 20)
        return {
          text: EstadoEstadoStockENUM.NORMAL,
          color: 'green'
        }

      const stockCritico = (stock * 100) / stockMinimo;

      if (stockCritico <= 20)
        return {
          text: EstadoEstadoStockENUM.CRITICO,
          color: 'red'
        }

      return {
        text: 'STOCK MINIMO',
        color: 'orange'
      } */
    },
    [],
  )


  /* const [details, setDetails] = useState<{ serie: string; cantidad: number }[]>([]);

  const [isOpenModal, setIsOpenModal] = useState(false) */

  /*const [details, setDetails] = useState<any[]>([]);
  const [isOpenModal, setIsOpenModal] = useState(false);

   const onDetails = (e: any) => {
    if (!e.series?.length) return toast.error('No existen series para este producto.');

    let formattedSerie: any[] = [];

    if (e.producto_data?.usa_metros) {
      // Usa metros → tomamos series_data y su cantidad (metros_actuales)
      formattedSerie = e.series_data?.map((s: any) => ({
        serie: s.numero_serie || s.serie,
        cantidad: Number(s.metros_actuales || 0), // cantidad en metros
      })) || [];
    } else {
      // No usa metros → tomamos series normales
      formattedSerie = e.series?.map((s: any) => ({
        serie: s,
        cantidad: 1, // por cada unidad
      }));
    }

    setIsOpenModal(true);
    setDetails(formattedSerie);
  }; */

  const isOpenModal = useSeriesReporteStock(s => s.isOpenModal)
  const setIsOpenModal = useSeriesReporteStock(s => s.setIsOpenModal)
  const setParams = useSeriesReporteStock(s => s.setParams)
  const setProducto = useSeriesReporteStock(s => s.setProducto)

  const columnsSeries = useMemo<MRT_ColumnDef<{ series: string }>[]>(
    () => [
      {
        header: "#", // encabezado de la columna
        Cell: ({ row }) => row?.index + 1, // row.index empieza en 0
        size: 40,
      },
      {
        accessorKey: 'serie',
        header: 'Serie'
      },
      {
        accessorKey: 'cantidad',
        header: 'Cantidad',

      }
    ], []
  )
  const producto = useSeriesReporteStock(s => s.producto)

  const columnsSeriesReporteInventario = useMemo<MRT_ColumnDef<IDataSerieParams>[]>(
    () => [
      {
        accessorKey: 'serie',
        header: 'Serie'
      },
      {
        accessorKey: 'metros_actuales',
        header: 'Cantidad',
        Cell: ({ row }) => {
          const metros = Number(row.original.metros_actuales)
          const usa_metros = producto?.usa_metros ?? false;
          return usa_metros ? metros : "1";
        }
      }
    ], [producto?.id_producto]
  )

  const columnsBase = useMemo<MRT_ColumnDef<IUbicacionProducto>[]>(() => [
    {
      ...cellNotFilter,
      accessorKey: 'series',
      header: 'Serie',
      Cell: ({ row }) => {
        return (
          <Button
            variant="text"
            size="small"
            onClick={() => {
              setIsOpenModal(true)
              setParams({
                producto: row.original.producto_data?.codigo,
                ubicacion: row.original.ubicacion,
                bodega: row.original.bodega,
              })
              setProducto(row.original.producto_data as IDataProducto)
              //onDetails(row.original as any)
            }}
            disabled={!row.original.series?.length}
          >
            VER SERIES
          </Button>
        )
      }
    },
    {
      accessorKey: 'producto_data.codigo',
      header: 'Codigo',
      size: 150,
    },
    {
      id: 'descripcion_producto',
      accessorKey: 'producto_data.descripcion',
      header: 'descripcion',
    },
    /*  {
       accessorKey: 'stock',
       header: 'Stock en Ubicacion'
     },
     {
       accessorKey: 'producto_data.stock_actual',
       header: 'Stock General'
 
     }, */
    {
      accessorKey: 'stock',
      header: 'Stock en ubicación',
      Cell: ({ row }) => {
        const usaMetros = row.original.producto_data?.usa_metros === true;
        const valor = usaMetros
          ? row.original.metros_actuales
          : row.original.stock;
        return (
          <span>
            {valor} {usaMetros ? '(METROS)' : ''}
          </span>
        );
      },
      /* Cell:({row})=>{
        return row.original?.producto_data?.usa_metros
        ? row.original?.metros_actuales : row.original?.producto_data?.metros_actuales
      } */
    },

    /* {
      accessorKey: 'producto_data.stock_actual',
      header: 'Stock General'

    }, */
    /* {
      ...cellNotFilter,
      accessorKey: 'stock',
      header: 'Stock en ubicación',
      Cell: ({ row }) => {
        const usaMetros = row.original.producto_data?.usa_metros === true;
        const valor = usaMetros
          ? row.original.metros_actuales
          : row.original.stock;
        console.log('valor',valor)
        return (
          <span>
            {valor} {usaMetros ? 'metros' : ''}
          </span>
        );
      },
      /* Cell:({row})=>{
        return row.original?.producto_data?.usa_metros
        ? row.original?.metros_actuales : row.original?.producto_data?.metros_actuales
      } */
    /*}, */

    /* {
      ...cellNotFilter,
      accessorKey: 'metros_actuales',
      header: 'Stock General',
      size: 140,
      Cell: ({ row }) => {
        const usaMetros = row.original.producto_data?.usa_metros;
        const valor = usaMetros
          ? row.original.metros_actuales
          : row.original.producto_data?.stock_actual;

        return (
          <span>
            {valor} {usaMetros ? '(usa_metros)' : '(normal)'}
          </span>
        );
      },
    }, */
    /* {
      ...cellNotFilter,
      accessorKey: 'metros_actuales',
      header: 'Stock General',
      size: 140,
      Cell: ({ row }) => {
        const usaMetros = row.original.producto_data?.usa_metros;
        const valor = usaMetros
          ? row.original.metros_actuales
          : row.original.producto_data?.stock_actual;
  
        return (
          <span>
            {valor} {usaMetros ? '(usa_metros)' : '(normal)'}
          </span>
        );
      },
    },
    /* {
      ...cellNotFilter,
      accessorKey: 'metros_actuales',
      header: 'stock General',
      size: 140,
      Cell: ({ row }) => {
  
        return row.original.producto_data?.usa_metros ?
          row.original.metros_actuales
          : row.original.producto_data?.stock_actual
      }
    }, */
    {
      ...cellNotFilter,
      accessorKey: 'producto_data.stock_minimo',
      header: 'stock minimo',
      size: 140,
    },
    {
      ...cellNotFilter,
      accessorKey: 'producto_data.stock_maximo',
      header: 'stock máximo',
      size: 140,
    },
    {
      ...cellNotFilter,
      accessorKey: 'producto_data.stock_seguridad',
      header: 'stock seguridad',
      size: 140,
    },
    {
      ...cellNotFilter,
      accessorKey: 'estado_reporte',
      header: 'Estado',
      size: 140,
      Cell: ({ row }) => {

        const resp = handleReporteStock(
          +row.original.stock,
          +row.original.producto_data?.stock_seguridad!,
          +row.original.producto_data?.stock_minimo!,
          +row.original.producto_data?.stock_maximo!
        )

        return <EstadoComponente backgroundColor={resp.color} texto={resp.text} />
      }
    },
    {
      ...cellNotFilter,
      accessorKey: 'producto_data.categoria_producto',
      header: 'categoria',
    },
    {
      ...cellNotFilter,
      accessorKey: 'bodega_data.nombre',
      header: 'Bodega',
      Cell: ({ row }) => {
        return emptyCellObject(row.original.bodega_data, 'nombre')
      }
    },
    {
      ...cellNotFilter,
      accessorKey: 'ubicacion_data.nombre',
      header: 'Ubicacion',
      Cell: ({ row }) => {
        return emptyCellObject(row.original.ubicacion_data, 'nombre')
      }
    }

  ], []);



  const columnsReporteStock = useMemo<MRT_ColumnDef<ReporteStockHistorico>[]>(
    () => [
      {
        accessorKey: 'bodega',
        header: 'bodega',
        Cell: ({ row }) => emptyCellObject(row.original.bodega_data, 'nombre')
      },
      {
        accessorKey: 'ubicacion',
        header: 'ubicacion',
        Cell: ({ row }) => emptyCellObject(row.original.ubicacion_data, 'nombre')
      },
      {
        accessorKey: 'fecha_reporte',
        header: 'Fecha Reporte',
        Cell: ({ row }) => {
          return formatDateWithTime(row.original.fecha_reporte)
        }
      },
    ], []
  )


  const columnsReporteInventariable = useMemo<MRT_ColumnDef<IUbicacionProducto>[]>(() => [
    {
      ...cellNotFilter,
      id: 'bodega_nombre',
      accessorKey: 'bodega_data.nombre',
      header: 'Bodega',
      Cell: ({ row }) => {
        return emptyCellObject(row.original.bodega_data, 'nombre')
      }
    },
    {
      ...cellNotFilter,
      id: 'ubicacion_nombre',
      accessorKey: 'ubicacion_data.nombre',
      header: 'Ubicacion',
      Cell: ({ row }) => {
        return emptyCellObject(row.original.ubicacion_data, 'nombre')
      }
    },
    {
      ...cellNotFilter,
      id: 'categoria_nombre',
      accessorKey: 'producto_data.categoria_producto',
      header: 'Ubicacion',
      Cell: ({ row }) => {
        return emptyCellObject(row.original.producto_data, 'categoria_producto')
      }
    },
    {
      id: 'producto',
      accessorKey: 'producto_data.codigo',
      header: 'Codigo',
      size: 150,
    },
    {
      id: 'descripcion_producto',
      accessorKey: 'producto_data.descripcion',
      header: 'descripcion',
    },
    {
      id: 'modelo_producto',
      accessorKey: 'producto_data.modelo_producto',
      header: 'Modelo',
      Cell: ({ row }) => {
        return emptyCellObject(row.original.producto_data, 'modelo_producto')
      }
    },
    {
      ...cellNotFilter,
      accessorKey: 'series',
      header: 'Serie',
      Cell: ({ row }) => {
        return (
          <Button
            variant="text"
            size="small"
            onClick={() => {
              setIsOpenModal(true)
              setParams({
                producto: row.original.producto_data?.codigo,
                ubicacion: row.original.ubicacion,
                bodega: row.original.bodega,
              })
              setProducto(row.original.producto_data as IDataProducto)
              //onDetails(row.original as any)
            }}
            disabled={!row.original.series?.length}
          >
            VER SERIES
          </Button>
        )
      }
    },
    {
      accessorKey: 'stock',
      header: 'Stock en ubicación',
      Cell: ({ row }) => {
        const usaMetros = row.original.producto_data?.usa_metros === true;
        const valor = usaMetros
          ? row.original.metros_actuales
          : row.original.stock;
        return (
          <span>
            {valor} {usaMetros ? '(METROS)' : ''}
          </span>
        );
      },
    },

    {
      id: 'costo_compra',
      accessorKey: 'producto_data.costo_compra',
      header: 'Costo compra',
      Cell: ({ row }) => {
        return emptyCellObject(row.original.producto_data, 'costo_compra')
      }
    },
    {
      id: 'costo_promedio',
      accessorKey: 'producto_data.costo_promedio',
      header: 'Costo promedio',
      Cell: ({ row }) => {
        return emptyCellObject(row.original.producto_data, 'costo_promedio')
      }
    },
    /* {
      ...cellNotFilter,
      accessorKey: 'estado_reporte',
      header: 'Estado',
      size: 140,
      Cell: ({ row }) => {

        const resp = handleReporteStock(
          +row.original.stock,
          +row.original.producto_data?.stock_seguridad!,
          +row.original.producto_data?.stock_minimo!,
          +row.original.producto_data?.stock_maximo!
        )

        return <EstadoComponente backgroundColor={resp.color} texto={resp.text} />
      }
    },


    {
      ...cellNotFilter,
      accessorKey: 'fecha_creacion',
      header: 'fecha_creacion',
      Cell: ({ row }) => {
        return formatDateWithTime(row.original.fecha_creacion!)
      }
    }, */


  ], []);


  return {
    columnsBase,
    isOpenModal,
    setIsOpenModal,
    //details,
    columnsSeries,
    columnsSeriesReporteInventario,
    columnsReporteStock,
    columnsReporteInventariable
  }
}